<template>
  <div v-if="appendData" nav-mode="light">
    <div v-if="busy" class="row text-center">
      <i class="fas fa-5x fa-spinner"></i>
      <p id="cancel-label">Fetching details...</p>
    </div>

    <div v-if="!busy" class="row my-3">
      <div class="col-md-8 offset-2">
        <NetworkBlogPostForm :network="network" :post="post" @form-updated="formUpdated" @network-blog-post-form-submit="$router.push('/networks/' + slug + '/blog')" />
      </div>
    </div>
    <b-modal v-model="showDraftModal" hide-footer hide-header>
      <div class="text-center m-2">
        <span>You have unsaved changes! What would you like to do?</span>
        <a id="discard" data-test="discard" :href="newPath" class="btn btn-block btn-danger mt-4 me-2" style="padding: 0.425rem 1.9rem !important;">Discard</a>
        <button id="save_as_draft" data-test="save_as_draft" class="btn btn-block btn-primary mt-4 ms-2" style="padding: 0.425rem 1.9rem !important;" @click="$bus.emit('save-post-draft')">Save as draft</button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import NetworkBlogPostForm from './NetworkBlogPostForm.vue';

export default {
  components: {
    NetworkBlogPostForm,
  },
  props: {
    slug: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      busy: true,
      network: null,
      post: null,
      formLeaveWithoutSave: false,
      showDraftModal: false,
      newPath: null,
    };
  },
  computed: {
    appendData() {
      if (this.id !== null) {
        return this.network && this.post;
      } else {
        return this.network;
      }
    },
  },
  watch: {
    slug(newV) {
      if (newV != this.network.slug) this.refresh();
    },
  },
  mounted() {
    this.refresh();
    
  },
  beforeRouteLeave (to) {
    if(this.formLeaveWithoutSave){
      this.newPath = to.path;
      this.showDraftModal = true;
    }
  },
  methods: {
    formUpdated(value){
      this.formLeaveWithoutSave = value;
    },
    // check the route parameter and the store, and refresh it if needed
    refresh() {
      if (this.network == null || this.network.slug != this.slug) {
        // refresh it!
        this.busy = true;
        this.$http.get('networks/' + this.slug).then(resp => {
          this.network = resp.data;
          this.busy = false;
        });
      }
      if (this.id) {
        // refresh it!
        this.busy = true;
        this.$http.get('networks/' + this.slug + '/blog/post/' + this.id).then(response => {
          this.post = response.data.post;
          this.busy = false;
        });
      }
    },
  },
};
</script>